/*
  example ad
  {
    componentInfo: {
      type: 'GPT',
      'unit-name': 'masthead',
      class: 'mb-2.5 u-center',
    },
    condition: {
      show: {
        articleId: [],
        categoryName: ['Cafe'],
        tagName: [],
      },
      hide: {
        articleId: [],
        categoryName: ['Cafe'],
        tagName: [],
      },
    },
  },
*/

export const articleBlocks = {
  desktop: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mb-2.5 u-center',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            className: 'mx-auto mb-3.5 u-center inline',
            cid: '924288',
            size: '970x250',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            style: 'top: 120px; left: 50px; width: 0; height: 0;',
            cid: '1023399',
            size: '160x600',
            fixed: true,
            className: 'fixed',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1781582',
            size: '970x250',
            class: 'u-center hidden sm:flex',
          },
        },
      ],
    },
    articleTaboola: {
      ads: [
        {
          componentInfo: {
            type: 'Taboola',
            targeting: 'article',
            mode: 'infinite',
          },
        },
      ],
    },
    articleIdealMedia: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            mode: 'feed',
          },
        },
      ],
    },
    articleSTNIdealMedia: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            mode: 'stnWidget',
          },
        },
      ],
    },
    articleSTNTaboola: {
      ads: [
        {
          componentInfo: {
            type: 'Taboola',
            targeting: 'article',
            mode: 'thumbnails',
          },
        },
      ],
    },
    newSidebarSponTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikYaniSponTop',
          },
        },
      ],
    },
    newSidebarTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikYaniTop',
          },
        },
      ],
    },
    newSidebarSticky: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikYaniMid3',
          },
        },
      ],
    },
    icerikArasiTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiTopLeft',
            className: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiTopRight',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1492416',
            size: '635x300',
            class: 'u-center hidden sm:block',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
      ],
    },
    icerikArasiBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiBottomLeft',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiBottomRight',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
      ],
    },
    icerikSonuBottom: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            'unit-name': 'icerikSonuBottom',
            mode: 'widget',
          },
        },
        // {
        //   componentInfo: {
        //     type: 'Taboola',
        //     targeting: 'article',
        //     'unit-name': 'icerikSonuBottom',
        //     mode: 'belowarticle',
        //   },
        // },
      ],
    },
    icerikArasiMiddle1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle1Left',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle1Right',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'Taboola',
            targeting: 'article',
            'unit-name': 'icerikArasiMiddle1',
            mode: 'midarticle',
          },
        },
      ],
    },
    icerikArasiMiddle2: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle2Left',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle2Right',
            class: 'u-center w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'w-1/2 hidden sm:flex',
          },
        },
        {
          componentInfo: {
            type: 'Adblock',
            cid: '924289',
            size: '336x280',
            className: 'u-center',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1492415',
            size: '635x300',
            class: 'u-center hidden sm:block',
          },
        },
      ],
    },
    pageskinLeft: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'pageskinLeft',
            class: 'sticky',
            style: 'top: 100px',
            lazy: false,
          },
        },
      ],
    },
    pageskinRight: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'pageskinRight',
            class: 'sticky',
            style: 'top: 100px',
            lazy: false,
          },
        },
      ],
    },
    bottomBranding: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'bottomBranding',
            class: 'my-3',
            lazy: false,
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
          condition: {
            hide: {
              categoryName: ['Vitrin'],
            },
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    interstitialPaid: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitialPaid',
            lazy: false,
          },
        },
      ],
    },
  },
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mb-2.5 mx-auto u-center',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1781583',
            size: '320x100',
            class: 'u-center flex sm:hidden mb-3',
          },
        },
      ],
    },
    articleIdealMedia: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            mode: 'feed',
          },
        },
      ],
    },
    articleSTNIdealMedia: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            mode: 'stnWidget',
          },
        },
      ],
    },
    // articleTaboola: {
    //   ads: [
    //     {
    //       componentInfo: {
    //         type: 'Taboola',
    //         targeting: 'article',
    //         mode: 'infinite',
    //       },
    //     },
    //   ],
    // },
    // articleSTNTaboola: {
    //   ads: [
    //     {
    //       componentInfo: {
    //         type: 'Taboola',
    //         targeting: 'article',
    //         mode: 'thumbnails',
    //       },
    //     },
    //   ],
    // },
    icerikArasiTop: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiTop',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1781585',
            size: '320x480',
            class: 'u-center block sm:hidden',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'u-center sm:hidden w-full',
          },
        },
      ],
    },
    icerikArasiBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiBottom',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'Taboola',
            'unit-name': 'icerikArasiBottom',
            targeting: 'article',
            mode: 'bottomarticle',
          },
        },
      ],
    },
    icerikSonuBottom: {
      ads: [
        {
          componentInfo: {
            type: 'IdealMedia',
            targeting: 'article',
            'unit-name': 'icerikSonuBottom',
            mode: 'widget',
          },
        },
        // {
        //   componentInfo: {
        //     type: 'Taboola',
        //     targeting: 'article',
        //     'unit-name': 'icerikSonuBottom',
        //     mode: 'belowarticle',
        //   },
        // },
      ],
    },
    icerikArasiMiddle1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle1',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'Taboola',
            targeting: 'article',
            'unit-name': 'icerikArasiMiddle1',
            mode: 'midarticle',
          },
        },
      ],
    },
    icerikArasiMiddle2: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikArasiMiddle2',
            class: 'u-center sm:hidden w-full',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1781586',
            size: '320x480',
            class: 'u-center block sm:hidden',
          },
        },
        {
          componentInfo: {
            type: 'SponsoredArticle',
            class: 'u-center sm:hidden w-full',
          },
        },
      ],
    },
    icerikSonuDikey: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikSonuDikey1',
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'icerikSonuDikey2',
            class: 'mt-2.5',
          },
        },
      ],
    },
    StnMasthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'StnMasthead',
            class: 'text-center u-center mt-4 mb-2.5',
          },
        },
      ],
    },
    bottomBranding: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'bottomBranding',
            class: 'my-3',
            lazy: false,
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
          condition: {
            hide: {
              categoryName: ['Vitrin'],
            },
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'FooterAd',
          },
        },
        {
          componentInfo: {
            type: 'Criteo',
            cid: '1781583',
            size: '320x100',
            class: 'u-center block sm:hidden',
          },
        },
      ],
    },
    interstitialPaid: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitialPaid',
            lazy: false,
          },
        },
      ],
    },
  },
};
